import { DocStatus } from "../services/utils";

export class PatientDoc {
  associatedAuthorizationId: string;
  documentType: string;
  documentTypeId: string;
  extension: string;
  fileKey: string;
  fileLink: string;
  fileName: string;
  id: string;
  isProcedureDocument: boolean;
  name: string;
  patientId: string;
  procedureId: string;
  encounterId: string;
  status: DocStatus;
  updatedBy: string;
  createdAt: string;
  dos: string;
  isAutogenerated?: boolean;
  autogeneratedContent?: string;
  isOld?: boolean;
  key?: string;
  updatedAt?: string;
  isPendingUpload?: boolean; // Flag for pending upload contexts
  contextId?: string; // Reference to original context ID
  isContextDocument?: boolean; // Flag for Document contexts excluded from SOAP
  /** Synthetic Global Documents row — opens procedure summary PDF. */
  isProcedureSummaryPdf?: boolean;
  /** Synthetic Global Documents row — medication order PDF is generated on preview. */
  isMedicationOrderPreview?: boolean;
  /** Synthetic Global Documents row — opens diagnostic imaging study viewer. */
  isDiagnosticImagingStudy?: boolean;
  studyHashId?: string;
  patientDocumentId?: string; // Patient document ID if document is uploaded
  /** Optional JSON from PATCH /documents/{id}/metadata (e.g. OCR). */
  metadata?: Record<string, unknown> | null;
}

export class ProcedureDoc {
  id?: string;
  name: string;
  status: "Draft" | "Submitted" | "Signed";
}

export class UploadPatientDoc {
  name: string;
  documentDate: string;
  patientId: string;
  procedureId: string;
  encounterId: string;
  documentType: string;
  dos: string;
  docData: {
    base64String: string;
    contentType: string;
  };
  constructor(
    patientId: string,
    encounterId: string,
    procedureId: string,
    documentType: string
  ) {
    this.patientId = patientId;
    this.procedureId = procedureId;
    this.encounterId = encounterId;
    this.documentType = documentType || null;
    this.name = "";
    this.docData = {
      base64String: "",
      contentType: "",
    };
  }
}
